import React, { useState } from "react";
import { Category, Cause, Issue, Lesson } from "../../types/Lessons";
import { Box, Divider, IconButton, List, ListItem, Stack } from "@mui/material";
import { EditableTextField } from "../Shared/FormItems";
import EditIcon from '@mui/icons-material/Edit';
import Api from "../../network/Api";
import CategoryAutocomplete from "../Shared/CategoryAutocomplete";

const FishboneChart = (props: { lesson: Lesson, editable: boolean | undefined }) => {
  const middle = Math.ceil(props.lesson.causes.length / 2);

  const [causes, setCauses] = useState(props.lesson.causes);

  const updateCause = (issue: Issue) => {
    Api.put(`/lessons/${props.lesson.id}/causes/${issue.id}`, { issue: issue.issue })
      .then(issue => {
        setCauses(causes.map(cause => {
          if (cause.category.id == issue.category_id) {
            return { ...cause, issues: cause.issues.map(i => i.id == issue.id ? issue : i) }
          } else {
            return cause;
          }
        })
      )})
  }

  return <Box className="fishboneChart">
    <Box className="causes">
      <Box>{causes.slice(0, middle).map(cause => <Bone key={cause.category.id} lesson={props.lesson} cause={cause} position="top" editable={props.editable} onSave={updateCause} /> )}</Box>
      <Divider />
      <Box>{causes.slice(middle).map(cause => <Bone key={cause.category.id} lesson={props.lesson} cause={cause} position="bottom" editable={props.editable} onSave={updateCause} /> )}</Box>
    </Box>
    <Box className="effect">{props.lesson.headline}</Box>
  </Box>
};

const Bone = (props: { lesson: Lesson, cause: Cause, position: "top" | "bottom", editable: boolean | undefined, onSave: (issue: Issue) => void }) => {
  return <Box className="bone">
    { props.position == "top" && <EditableCategory lesson={props.lesson} cause={props.cause} editable={props.editable} /> }
    <Box className="issues">
      <List>
        {props.cause.issues.map(issue => <ListItem key={issue.id} disablePadding>
          { props.editable ? <EditableTextField 
                                      placeholderElement={<small>{issue.issue}</small>}
                                      placeholder="Describe root cause"
                                      defaultValue={issue.issue}
                                      rows={5}
                                      onSave={value => props.onSave({...issue, issue: value}) } /> : <small>{issue.issue}</small> }
        </ListItem>)}
      </List>
      <Box className={`diagonal ${props.position == "top" ? "topBottom" : "bottomTop"}`}></Box>
    </Box>
    { props.position == "bottom" && <EditableCategory lesson={props.lesson} cause={props.cause} editable={props.editable} /> }
  </Box>
}

const EditableCategory = (props: { lesson: Lesson, cause: Cause, editable: boolean | undefined }) => {

  const [editing, setEditing] = useState(false);
  const [category, setCategory] = useState(props.cause.category);

  const changeCategory = (category: Category | null) => {
    if (category === null) { return }
    Api.put(`/lessons/${props.lesson.id}/causes/${props.cause.id}`, { category_id: category.id }).then(cause => setCategory(category));
  }

  return <Stack direction="row" alignItems="center" className="category">
    { editing ? <CategoryAutocomplete value={category} onChange={changeCategory} onClose={() => setEditing(false)} /> : <Box>{category.name}</Box> }
    { props.editable && !editing && <IconButton color="info" size="small" onClick={() => setEditing(true)}><EditIcon fontSize="small" /></IconButton> }
  </Stack>
}

export default FishboneChart;